
/* injects from baggage-loader */

'use strict';

const indexOf = [].indexOf || function (item) {
  for (var i = 0, l = this.length; i < l; i++) {
    if (i in this && this[i] === item) {
      return i;
    }
  }
  return -1;
};

const moduleEditormenu = angular.module('services.editorNavSections', ['services.layoutEditor.sectionDragDrop']);

moduleEditormenu.factory('editorNavSections', [
  '$timeout', 'layoutEditor', 'insertSpace', 'ns', 'sectionDragDrop', '$injector', 'Section', 'blocksBuilder', 'Site', '$rootScope', 'blockOverlays', 'editorDragPanel', 'Animation', 'Template', 'Tutorials', 'MapInit', 'Timer', 'Parallax', 'TimeMachine', 'Notification', 'SectionEmail', 'SectionLesson', '$state', 'FrameForm',
  ($timeout, layoutEditor, insertSpace, ns, sectionDragDrop, $injector, Section, blocksBuilder, Site, $rootScope, blockOverlays, editorDragPanel, Animation, Template, Tutorials, MapInit, Timer, Parallax, TimeMachine, Notification, SectionEmail, SectionLesson, $state, FrameForm) => {
    let Y;

    YUI().use('dd', 'dd-constrain', 'dd-drop', 'dd-scroll', function(y) {
      Y = y;
    });

    if ($state.current.name === 'email.page.editor') {
      Section = SectionEmail;
    }

    if ($state.current.name === 'lesson.page.editor') {
      Section = SectionLesson;
    }

    const editorNavSections = {
      availableTags: ['section', 'header', 'footer'],
      /**
       * buildNewSection
       * @param drag
       * @param cloned
       * @returns {*}
       */
      buildNewSection: function(drag, cloned) {
        if (cloned === null || cloned === undefined) {
          cloned = false;
        }

        this.newsection = blocksBuilder.createSection(ns.sectionLoader, this.newSectionType);
        editorDragPanel.cloneSectionDisabled = true;
        this.cloned = cloned;
        this.setContentHTML(drag, this.newsection);

        return this.newsection;
      },
      editorNavSetTab: function(tab) {
        $rootScope.editorNavTab(tab);
      },
      setContentHTML: function(drag) {
        const $dragNode = $(drag._node);
        const sectionId = $dragNode.scope().item && $dragNode.scope().item.id || drag.section.id;
        this.createSiteSection(sectionId);
      },
      lockSections: function() {
        if (this.ddInstances) {
          this.ddInstances.forEach(function(v) {
            v.set('lock', true);
          });
        }
      },
      unlockSections: function() {
        if (this.ddInstances) {
          this.ddInstances.forEach(function(v) {
            v.set('lock', false);
          });
        }
      },
      createSiteSection: function(sectionId) {
        let createFunc = Section.create;

        if (this.cloned) {
          createFunc = Section.clone;
        }

        const self = this;

        createFunc(sectionId, this.newSectionType).then(function(sectionData) {
          $rootScope.$broadcast('get:styles', false, function() {
            self.getSiteNewSectionHtml(sectionData);
            self.indexPosition = undefined;
            $rootScope.$broadcast('sectionFonts:loaded', sectionData.fonts_attributes);
            self.newSectionType = undefined;
          });
        }, function(response) {
          self.unlockSections();
          Notification.error('Неизвестная ошибка (' + response.status + ')');
          self.newsection.remove();
        });
      },
      findMapsInNewSection: function(sectionId) {
        return $('[data-section-id=\'' + sectionId + '\']').find('.strw__map');
      },
      findTimersInNewSection: function(sectionId) {
        return $('[data-section-id=\'' + sectionId + '\']').find('.strbw-timer');
      },
      sectionInitializer: function(sectionData, htmlData, newsection, withCapture) {
        if (withCapture === null || withCapture === undefined) {
          withCapture = true;
        }

        const self = this;
        const newSectionId = sectionData.id;

        newsection.addClass('ls_' + newSectionId);
        newsection.one(ns.wrapperClass).addClass('ls_' + newSectionId + '-wrapper');

        const htmlContent = $(htmlData).find(ns.wrapperClass).html();

        Animation.prepareSlideDown(newsection);
        newsection.one(ns.wrapperClass).set('innerHTML', htmlContent);
        $(newsection._node).find('.frame-form iframe').each(function() {
          $(this)[0].contentWindow.stop();
        });

        FrameForm.updateFrameForms(newsection);
        newsection.setAttribute('data-section-id', newSectionId);
        layoutEditor.setJSONtoSection(sectionData);
        if (newsection.hasClass('str-cloned__section')) {
          newsection.removeClass('str-cloned__section');
          newsection.edited = true;
        }
        const tagname = newsection.get('tagName').toLowerCase();
        if (tagname === 'section') {
          layoutEditor.setHandleSections(newsection);
        }

        editorDragPanel.addPanelSection(newsection);
        editorDragPanel.bindSectionClickable(newsection);
        layoutEditor.singleSectionInitializer(newsection);
        Animation.slideDown(newsection);
        $rootScope.$broadcast('section:created', newsection);

        this.unlockSections();

        $timeout(function() {
          $(window).trigger('resize');
          blockOverlays.addOverlaysToBlocks();

          self.findMapsInNewSection(newSectionId).each(MapInit.initMap);
          self.findTimersInNewSection(newSectionId).each((index, element) => Timer.initTimer(index, element));

          editorDragPanel.cloneSectionDisabled = false;
          if (!self.cloning) {
            editorDragPanel.startEditingLayout({
              target: newsection.one(ns.wrapperClass)
            }, layoutEditor);
          } else {
            self.cloning = false;
          }
        }, 300);

        if (withCapture) {
          this.captureCreate(newsection);
        }

        if (!this.cloned) {
          this.clearFonts(newsection);
        }

        this.cloned = false;
      },
      clearFonts: function(newSection) {
        if (Editor.mode === 'site.page.editor') {
          if ($rootScope.site.default_font.family || $rootScope.site.h_font.family) {
            $('[data-section-id=\'' + newSection.section.id + '\'] *').filter(function() {
              if ($(this).attr('style')) {
                if ($(this).attr('style').indexOf('font-family') > -1) {
                  $(this).css({fontFamily: ''});
                }
              }
              if ($(this).prop('tagName') === 'FONT') {
                return $(this).removeAttr('face');
              }
            });

            layoutEditor.setFontToJsonWidgets(newSection, {
              'default': $rootScope.site.default_font.family,
              h: $rootScope.site.h_font.family
            });
          }
        }
      },
      captureCreate: function(newsection) {
        const sectionHTML = newsection.get('outerHTML');
        const prevSectionId = newsection.previous() && newsection.previous().getData('section-id') || undefined;

        TimeMachine.capture('addSection', newsection.section, sectionHTML, prevSectionId);
      },
      getSiteNewSectionHtml: function(sectionData) {
        const self = this;
        Section.getHTML(sectionData).then(function(htmlData) {
          self.sectionInitializer(sectionData, htmlData, self.newsection);
        });
      },
      destroyDropSections: function() {
        const sectionlist = Y.all(ns.sectionClass);

        sectionlist.each(function(v) {
          const id = v.get('id');
          const dr = Y.DD.DDM.getDrop('#' + id);
          if (dr) {
            dr.destroy();
          }
        });

        if (this.dropBackdrop) {
          this.dropBackdrop.destroy();
        }

        if (this.dropHeader) {
          this.dropHeader.destroy();
        }

        if (this.dropFooter) {
          this.dropFooter.destroy();
        }
      },
      bindSectionOnDropInTemplate: function(v) {
        return new Y.DD.Drop({
          node: v
        });
      },
      bindSectionsOnDropInTemplate: function() {
        const sectionsInWrapper = Y.all(ns.sectionClass);

        sectionsInWrapper.each(this.bindSectionOnDropInTemplate);

        this.dropBackdrop = new Y.DD.Drop({
          node: ns.dropBackdropClass
        });
        this.dropHeader = new Y.DD.Drop({
          node: ns.dropHeaderClass
        });
        this.dropFooter = new Y.DD.Drop({
          node: ns.dropFooterClass
        });

        new Y.DD.Drop({
          node: '#mini-sections'
        });
      },
      _destroyBindDragSectionsInCollection: function() {
        Y.DD.DDM.detachAll();

        const listMiniSections = Y.all('#mini-sections .etnr-item__link');

        listMiniSections.each(function(v) {
          const id = v.get('id');
          const dd = Y.DD.DDM.getDrag('#' + id);
          const dr = Y.DD.DDM.getDrop('#' + id);
          if (dd) {
            dd.destroy();
          }
          if (dr) {
            dr.destroy();
          }
          if (dd) {
            dd._unprep();
          }
        });
      },
      bindDragSectionsInCollection: function() {
        const self = this;

        insertSpace.init(Y);
        this.ddInstances = [];

        const layoutEditor = $injector.get('layoutEditor');
        const lis = Y.all('#mini-sections .etnr-item__link');

        lis.each(function(v) {
          const dd = new Y.DD.Drag({
            node: v,
            target: {
              padding: '0 0 0 20'
            }
          }).plug(Y.Plugin.DDProxy, {
            moveOnEnd: false
          }).plug(Y.Plugin.DDWinScroll);

          dd.before('drag:start', sectionDragDrop._beforeDragStart, sectionDragDrop);
          dd.on('drag:start', self._onDragStart, sectionDragDrop);
          dd.on('drag:end', self._onDragEnd, self);
          dd.on('drag:drophit', self._onDropHit, self);
          dd.on('drag:over', self._onDragOver, self);

          if (layoutEditor.isTouchEnabled()) {
            v.detach('click', self._onClick, self);
            v.on('click', self._onClick, self);
          } else {
            v.detach('click', Tutorials._sectionDropTutorial, Tutorials);
            v.on('click', Tutorials._sectionDropTutorial, Tutorials);
          }

          self.ddInstances.push(dd);
        });

        this.bindSectionsOnDropInTemplate();
      },
      _onClick: function(e) {
        this.removeOverClassFromAll();

        if ($rootScope.layoutIsEditing) {
          editorDragPanel.cancelSection();
        }

        this.newSectionType = 'default';
        const newSection = this.buildNewSection(e.target);

        Y.one(ns.dropBackdropClass).insert(newSection, 'after');
        this.bindSectionOnDropInTemplate(newSection);

        $rootScope.toggleCommonSections();
        insertSpace.hide();
      },
      _onDragStart: function(e) {
        sectionDragDrop._onDragStart(e);

        const drag = e.target;
        const originalEl = drag.get('node');
        const clone = drag.get('dragNode');
        const sectionPreviewImage = originalEl.one('img').getAttribute('src');

        clone.setStyles({backgroundImage: 'url(' + sectionPreviewImage + ')'});
      },
      removeOverClassFromAll: function() {
        Y.all('.yui3-dd-dropover').removeClass('yui3-dd-dropover');
        Y.all('.yui3-dd-dropover-red').removeClass('yui3-dd-dropover-red');
      },
      headerElementOver: function(sectionType) {
        this.removeOverClassFromAll();

        Y.one(ns.dropHeaderClass).addClass('yui3-dd-dropover');
      },
      footerElementOver: function(sectionType) {
        this.removeOverClassFromAll();

        Y.one(ns.dropFooterClass).addClass('yui3-dd-dropover');
      },
      contentElementOver: function(sectionType) {
        this.removeOverClassFromAll();

        Y.one(ns.dropBackdropClass).addClass('yui3-dd-dropover');
      },
      addOverClassToElements: function(sectionType) {
        // const overClass = "yui3-dd-dropover";
        const isHeaderElement = this.activeDropElement.hasClass(ns.dropHeaderClass.substr(1));
        const isFooterElement = this.activeDropElement.hasClass(ns.dropFooterClass.substr(1));
        const isContentElement = this.activeDropElement.hasClass(ns.dropBackdropClass.substr(1));

        if (isHeaderElement) {
          this.headerElementOver(sectionType);
        }
        if (isFooterElement) {
          this.footerElementOver(sectionType);
        }
        if (isContentElement) {
          this.contentElementOver(sectionType);
        }
        if (!isHeaderElement && !isFooterElement && !isContentElement) {
          this.removeOverClassFromAll();
        }
      },
      _onDragOver: function(e) {
        const blockDragDrop = $injector.get('blockDragDrop');

        this.activeDropElement = Y.DD.DDM.activeDrop.get('node');

        const drag = e.drag.get('node');
        const sectionType = $(drag._node).scope().item.section_type;

        this.addOverClassToElements(sectionType);

        if (this.activeDropElement.hasClass(ns.sectionClass.substr(1))) {
          this.nearestEdge = blockDragDrop.getDropInfo(Y);
          insertSpace.alignInsertSpaceRowOrSection(this.nearestEdge, 'section');
        } else {
          insertSpace.hide();
        }
      },
      removeDropBackdrop: function(drop) {
        Y.one(ns.dropBackdropClass).removeClass('no-sections');
        Y.one('.str-drop-backdrop').addClass('ng-hide');
      },
      _onDragEnd: function(e) {
        Y.one(ns.dropBackdropClass).removeClass('yui3-dd-dropover');
        Y.one(ns.dropHeaderClass).removeClass('yui3-dd-dropover');
        Y.one(ns.dropFooterClass).removeClass('yui3-dd-dropover');

        const drag = e.target;
        const drop = this.activeDropElement;
        const originalEl = drag.get('node');

        originalEl.setStyles({visibility: 'visible'});

        insertSpace.hide();
        if (drop.hasClass(ns.dropBackdropClass.substr(1))) {
          this.removeDropBackdrop(drop);
        }

        if (this.lock) {
          this.lockSections();
          this.lock = undefined;
        }
      },
      /**
       *
       * @param e
       * @returns {boolean}
       * @private
       */
      _onDropHit: function(e) {
        this.availableTags = ['section', 'header', 'footer'];

        const drop = e.drop.get('node');
        const drag = e.drag.get('node');
        const tplWrapper = Y.one(ns.tplContainer);
        const tagName = drop.get('tagName').toLowerCase();
        const sectionType = $(drag._node).scope().item.section_type;

        this.removeOverClassFromAll();

        if ($rootScope.layoutIsEditing) {
          editorDragPanel.cancelSection();
        }

        if (drop.hasClass(ns.dropBackdropClass.substr(1))) {
          if ($rootScope.isCollectionPage) {
            return false;
          }

          this.newSectionType = 'default';
          const newSection = this.buildNewSection(drag);

          Y.one(ns.dropBackdropClass).insert(newSection, 'after');

          this.bindSectionOnDropInTemplate(newSection);
        }

        if (drop.hasClass(ns.dropHeaderClass.substr(1))) {
          this.newSectionType = 'header';
          const newSection = this.buildNewSection(drag);

          tplWrapper.prepend(newSection);

          this.bindSectionOnDropInTemplate(newSection);
        }

        if (drop.hasClass(ns.dropFooterClass.substr(1))) {
          this.newSectionType = 'footer';
          const newSection = this.buildNewSection(drag);

          tplWrapper.append(newSection);

          this.bindSectionOnDropInTemplate(newSection);
        }

        if (indexOf.call(this.availableTags, tagName) >= 0) {
          if ($rootScope.isCollectionPage) {
            return false;
          }

          this.newSectionType = 'default';
          const newSection = this.buildNewSection(drag);

          if (this.nearestEdge.quad.y === 'top' && tagName === 'header') {
            return false;
          }
          if (this.nearestEdge.quad.y === 'bottom' && tagName === 'footer') {
            return false;
          }

          switch (this.nearestEdge.quad.y) {
            case 'top':
              this.indexPosition = $(drop._node).index();
              drop.insert(newSection, 'before');
              break;
            case 'bottom':
              this.indexPosition = $(drop._node).index() + 1;
              drop.insert(newSection, 'after');
              break;
          }

          $timeout(function() {
            Animation.scrollTo($(newSection._node));
          });

          this.bindSectionOnDropInTemplate(newSection);
        }

        this.lock = (
            !drop.hasClass('etn__tab-container') &&
            drop.hasClass(ns.dropBackdropClass.substr(1)) ||
            drop.hasClass(ns.dropHeaderClass.substr(1)) && sectionType === 'header' ||
            // drop.hasClass(ns.dropHeaderClass.substr(1)) && sectionType === 'header' ||
            indexOf.call(this.availableTags, tagName) >= 0
        );

        $rootScope.toggleCommonSections();
        insertSpace.hide();
      }
    };
    return editorNavSections;
  }
]);




// WEBPACK FOOTER //
// ./src/app/editor/editor_nav/sections/sections.service.js